import FullImage from "./fullImage";
export default FullImage;
